import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { EulaGuard } from './guards/eula.guard';
import { ShellComponent } from './components/shell.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'set-initial-password',
    loadComponent: () => import('./pages/set-initial-password/set-initial-password.page').then(m => m.SetInitialPasswordPage)
  },
  {
    path: 'change-password',
    loadComponent: () => import('./pages/change-password/change-password.page').then(m => m.ChangePasswordPage),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthGuard, EulaGuard],
    children: [
      {
        path: 'landing',
        loadComponent: () => import('./pages/landing/landing.page').then(m => m.LandingPage)
      },
      {
        path: 'user/create',
        loadComponent: () => import('./pages/user/create-user.page').then(m => m.CreateUserPage)
      },
      {
        path: 'project/create',
        loadComponent: () => import('./pages/project/create-project.page').then(m => m.CreateProjectPage)
      },
      {
        path: 'project/assign',
        loadComponent: () => import('./pages/project/assign-user.page').then(m => m.AssignUserPage)
      },
      {
        path: 'user/profile',
        loadComponent: () => import('./pages/user/user-profile.page').then(m => m.UserProfilePage)
      },
      {
        path: 'global-admin',
        loadComponent: () => import('./pages/global-admin/global-admin.page').then(m => m.GlobalAdminPage)
      },
      {
        path: 'global-metrics',
        loadComponent: () => import('./pages/global-metrics/global-metrics.page').then(m => m.GlobalMetricsPage)
      },
      {
        path: 'module-invoicing',
        loadComponent: () => import('./pages/module-invoicing/module-invoicing.page').then(m => m.ModuleInvoicingPage)
      },
      {
        path: 'global-users',
        loadComponent: () => import('./pages/global-users/global-users.page').then(m => m.GlobalUsersPage)
      },
      {
        path: 'active-invites',
        loadComponent: () => import('./pages/active-invites/active-invites.page').then(m => m.ActiveInvitesPage)
      },
      {
        path: 'user-requests',
        loadComponent: () => import('./pages/user-requests/user-requests.page').then(m => m.UserRequestsPage)
      },
      {
        path: 'device-management',
        loadComponent: () => import('./pages/device-management/device-management.page').then(m => m.DeviceManagementPage)
      },
      {
        path: 'eula-test',
        loadComponent: () => import('./pages/eula-test/eula-test.page').then(m => m.EulaTestPage)
      },
      {
        path: 'invite-viewer',
        loadComponent: () => import('./pages/invite-viewer/invite-viewer.page').then(m => m.InviteViewerPage)
      },
      {
        path: 'company/create',
        loadComponent: () => import('./pages/company/create-company.page').then(m => m.CreateCompanyPage)
      },
      {
        path: 'project-requests',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/project-requests/project-requests.page').then(m => m.ProjectRequestsPage)
          },
          {
            path: ':requestId',
            loadComponent: () => import('./pages/project-requests/project-request-detail.page').then(m => m.ProjectRequestDetailPage)
          }
        ]
      },
      {
        path: 'recommended-quick-hits',
        loadComponent: () => import('./pages/recommended-quick-hits/recommended-quick-hits.page').then(m => m.RecommendedQuickHitsPage)
      },
      {
        path: 'bulk-update-pilings',
        loadComponent: () => import('./pages/bulk-update-pilings/bulk-update-pilings.page').then(m => m.BulkUpdatePilingsPage)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'login'
  },
];
